import { gfhAPI } from 'API/httpClient';

function getCompanyInfo(userId: string) {
  return gfhAPI.get(
    `/mothership?path=gfh/mailer/api/v2/accounts/me&userId=${userId}`
  );
}

export function getActiveListings() {
  return gfhAPI.get('/getActiveUserRooms');
}

export default getCompanyInfo;
